exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sso-login-button {\n\tmargin-top: 10px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main